// Initialize Firebase

import firebase from 'firebase'
// Required for side-effects
require("firebase/firestore");


const config = {
    apiKey: "AIzaSyBsRiBQpozSzMA_kJD_Xr1m1c_ViaAAdRc",
    authDomain: "parishbulletin-82c8c.firebaseapp.com",
    databaseURL: "https://parishbulletin-82c8c.firebaseio.com",
    projectId: "parishbulletin-82c8c",
    storageBucket: "gs://parishbulletin-82c8c.appspot.com",
    messagingSenderId: "865608647668",
    appId: "1:865608647668:web:53fd2def585efdea252fa1",
    measurementId: "G-5Z2VF7B686"
};

firebase.initializeApp(config);

export const firebaseDB = firebase.database();

export const firestoreDB = firebase.firestore();

export const firestoreStorage = firebase.storage();

export const firestoreTimeStamp = firebase.firestore.FieldValue.serverTimestamp();

export const rawFirestore = firebase.firestore;
//
// const settings = {timestampsInSnapshots: true};
// firestore.settings(settings);

// export const firestoreDB = firestore;
